// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.flex-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}

.flex-item {
  padding: 5px;
  width: 600px;
  min-width: 320px;
}

@media (max-width: 1024px) {
  .helper-text {
    left: 15px !important;
  }
}
.success-icon {
  float: left;
  padding-top: 5px;
}

.alert {
  margin: 20px;
}

.submitting {
  height: 50px;
  margin-left: 45%;
  width: 50px;
}

.success-msg {
  color: #007a3d;
  margin: 5px;
  font: 24px/25px "Omnes-ATT-W02-Light";
}

.buttons-section {
  height: 115px;
  margin-bottom: 100px;
  max-width: 681px;
}

.mar-top-20 {
  margin-top: 20px;
}

.grid-table table {
  margin-bottom: 20px;
  border-collapse: collapse;
  border-spacing: 2px;
}
.grid-table table tbody {
  box-sizing: border-box;
  font-size: 16px;
}
.grid-table table tbody td.minPad {
  padding: 10px 20px;
}
@media (max-width: 1024px) {
  .grid-table table tbody td.minPad {
    padding: 20px;
  }
}
.grid-table table tbody td {
  font-size: 16px;
  border: 1px solid #d2d2d2;
  padding: 20px;
}
.grid-table table tbody td div.extTxt {
  display: block;
}
.grid-table table tbody td div.shortTxt {
  display: none;
}
@media (max-width: 1024px) {
  .grid-table table tbody td {
    font-size: 14px;
  }
  .grid-table table tbody td div.extTxt {
    display: none;
  }
  .grid-table table tbody td div.shortTxt {
    display: block;
  }
}
.grid-table table tbody td:nth-child(1) {
  width: 40%;
}
@media (max-width: 1024px) {
  .grid-table table tbody td:nth-child(1) {
    width: 60%;
  }
}
.grid-table table tbody td:nth-child(2) {
  width: 30%;
}
@media (max-width: 1024px) {
  .grid-table table tbody td:nth-child(2) {
    width: 20%;
  }
}
.grid-table table tbody td:nth-child(3) {
  width: 30%;
}
@media (max-width: 1024px) {
  .grid-table table tbody td:nth-child(3) {
    width: 20%;
  }
}
.grid-table table thead th {
  font-size: 14px;
}
.grid-table table thead th div.cmpTbHdrL {
  display: block;
}
.grid-table table thead th div.cmpTbHdrS {
  display: none;
}
@media (max-width: 1024px) {
  .grid-table table thead th div.cmpTbHdrL {
    display: none;
  }
  .grid-table table thead th div.cmpTbHdrS {
    display: block;
  }
}

.banner-section {
  align-items: center;
  height: 500px;
  overflow: hidden;
  position: relative;
  width: 99.4vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}
.banner-section .banner-caption {
  transform: translateY(-50%);
  transform: translateY(-50%);
  transform: translateY(-50%);
  transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  padding-left: 10px;
  position: absolute;
  top: 50%;
  width: 100%;
}
.banner-section .banner-caption #bannerNameSection {
  color: #191919;
  margin-bottom: 10px;
  margin-top: 0;
}
.banner-section .banner-caption #efotaBannerNameSection {
  color: #000000;
  margin-bottom: 10px;
  margin-top: 0;
  width: 67%;
  line-height: 40px;
  letter-spacing: 1.33px;
  opacity: 1;
  text-align: left;
}
.banner-section .banner-caption .product-text {
  margin-left: -15px;
  margin-right: -15px;
}
.banner-section .banner-caption .efota-product-text {
  margin-left: -15px;
  margin-right: -15px;
  width: 73%;
  text-align: left;
  letter-spacing: 0.48px;
  color: #000000;
  opacity: 1;
}
.banner-section img {
  left: 50%;
  max-width: 1920px;
  position: absolute;
  transform: translateX(-50%);
}

@media (max-width: 1024px) {
  .details-page {
    padding-bottom: 10px;
  }
  .banner-section {
    align-items: center;
    height: auto;
    overflow: hidden;
    position: relative;
  }
  .banner-section figure {
    height: 266px;
    overflow: hidden;
    position: relative;
  }
  .banner-section img {
    left: 50%;
    width: auto;
    max-width: 1024px;
    position: absolute;
    transform: translateX(-50%);
  }
  .banner-section .banner-caption {
    transform: none;
    transform: none;
    transform: none;
    transform: none;
    transform: none;
    left: 0;
    padding-left: 0;
    position: relative;
    width: 100%;
  }
  .banner-section .banner-caption h1 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 30px;
    margin-top: 20px;
  }
  .banner-section .banner-caption p {
    margin-bottom: 30px;
  }
  .banner-section .banner-caption .product-text {
    margin-left: -15px;
    margin-right: -15px;
  }
  .banner-section .banner-caption h2.product-style {
    margin-bottom: 20px !important;
  }
}
.tab-section {
  margin: 30px 0;
  position: relative;
  margin-bottom: 0;
}
@media (max-width: 1024px) {
  .tab-section {
    height: auto !important;
    margin: 0 -15px;
    margin-bottom: -10px;
  }
}
.tab-section label {
  color: black;
  font-size: 16px;
}
@media (max-width: 1024px) {
  .tab-section label {
    font-size: 14px;
  }
}
.tab-section .hidden-accessible {
  position: absolute !important;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  padding: 0 !important;
  border: 0 !important;
  height: 1px !important;
  width: 1px !important;
}
.tab-section #productDescription {
  line-height: 20px;
}
.tab-section .tabHeading {
  font: Medium 15px/26px var(--unnamed-font-family-att-aleck-sans);
  letter-spacing: 0.4px;
  font-weight: bold;
  opacity: 1;
}
.tab-section img {
  margin-right: 30px;
  margin-top: 10px;
  border: 1px solid #707070;
}
.tab-section .text-right {
  text-align: right;
}
.tab-section .device-link {
  margin-right: 185px;
  font-size: 16px;
  color: #0068ae;
}
.tab-section .device-link:hover, .tab-section .device-link:focus, .tab-section .underLine:hover, .tab-section .underLine:focus {
  color: #23527c;
  text-decoration: underline;
}
.tab-section .bold-text {
  margin-top: 19px;
  text-align: left;
  letter-spacing: 0.4px;
  color: #000000;
  opacity: 1;
}
.tab-section #unAuthFormText {
  font: Medium 15px/26px var(--unnamed-font-family-att-aleck-sans);
  letter-spacing: 0.4px;
  font-weight: bold;
  opacity: 1;
}
.tab-section #loginBtn1, .tab-section #loginBtn2, .tab-section #loginBtn4 {
  background: #1483D9 0% 0% no-repeat padding-box;
  border: 1px solid #1A84D8;
  border-radius: 6px;
  letter-spacing: var(--unnamed-character-spacing-0);
  background-color: #1483D9;
  text-align: center;
  letter-spacing: 0px;
  opacity: 1;
  color: #FFFFFF;
}
.tab-section .plainText {
  letter-spacing: 0.4px;
  opacity: 1;
}

.tab-moreinfo {
  margin-bottom: 15px;
}
.tab-moreinfo p {
  margin-top: 15px;
}

.tab-unauthinfo .btn {
  background: #1483D9 0% 0% no-repeat padding-box;
  border: 1px solid #1A84D8;
  border-radius: 6px;
  letter-spacing: var(--unnamed-character-spacing-0);
  background-color: #1483D9;
  text-align: center;
  letter-spacing: 0px;
  opacity: 1;
  color: #FFFFFF;
}

.cmptab-header {
  font-size: 24px;
  margin: 30px 0 20px 0;
}
@media (max-width: 1024px) {
  .cmptab-header {
    font-size: 16px;
  }
}

.package-section {
  background-color: hsl(0, 0%, 95%);
  padding-top: 30px;
}
.package-section .label-style {
  margin-bottom: 30px !important;
}
.package-section .msg {
  margin-bottom: 30px;
}
.package-section .tnc {
  margin: 0;
  padding-bottom: 10px;
  padding-left: 15px;
}
@media (max-width: 1024px) {
  .package-section .tnc {
    padding-left: 0;
  }
}
@media (max-width: 1024px) {
  .package-section {
    padding-top: 20px;
  }
  .package-section .label-style {
    margin-bottom: 20px !important;
  }
}

.display-column {
  display: flex;
  flex-wrap: wrap;
}

.modal-lg-width {
  max-width: 720px;
}

@media (max-width: 1024px) {
  .display-column {
    display: block;
    padding-bottom: 10px;
  }
}
p.label-style {
  margin-bottom: 30 px !important;
}

form {
  margin-top: 10px;
}

app-form-builder label {
  cursor: default;
}
app-form-builder .radio {
  margin-right: 20px;
  margin-top: 7px;
}
app-form-builder .checkbox {
  margin-left: 15px;
}
app-form-builder .link-content {
  margin-bottom: 15px;
}
app-form-builder .extra-content {
  font-size: 16px;
  margin-bottom: 8px;
}
@media (max-width: 1024px) {
  app-form-builder .extra-content {
    font-size: 14px;
  }
}
app-form-builder .text-main {
  padding-bottom: 0px;
}
app-form-builder .label-content {
  font-size: 16px;
  font-family: Omnes-ATT-W02-Medium;
  margin-bottom: 8px;
}
app-form-builder .tooltip-container i {
  margin: 4px 0 0 4px;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/details/details.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAmJF;;AAhJA;EACE,YAAA;EACA,YAAA;EACA,gBAAA;AAmJF;;AFvII;EERF;IACE,qBAAA;EAmJF;AACF;AAhJA;EACE,WAAA;EACA,gBAAA;AAkJF;;AA/IA;EACE,YAAA;AAkJF;;AA/IA;EACE,YAAA;EACA,gBAAA;EACA,WAAA;AAkJF;;AA/IA;EACE,cAAA;EACA,WAAA;EACA,qCAAA;AAkJF;;AA/IA;EACE,aAAA;EACA,oBAAA;EACA,gBAAA;AAkJF;;AA9IA;EACE,gBAAA;AAiJF;;AA7IE;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;AAgJJ;AA9II;EACE,sBAAA;EACA,eAAA;AAgJN;AA9IM;EACE,kBAAA;AAgJR;AFxLI;EEuCE;IAII,aAAA;EAiJR;AACF;AA9IM;EACE,eAAA;EACA,yBAAA;EACA,aAAA;AAgJR;AA9IQ;EACE,cAAA;AAgJV;AA7IQ;EACE,aAAA;AA+IV;AFxMI;EE+CE;IAcI,eAAA;EA+IR;EA7IQ;IACE,aAAA;EA+IV;EA5IQ;IACE,cAAA;EA8IV;AACF;AA1IM;EACE,UAAA;AA4IR;AFtNI;EEyEE;IAII,UAAA;EA6IR;AACF;AA1IM;EACE,UAAA;AA4IR;AF9NI;EEiFE;IAII,UAAA;EA6IR;AACF;AA1IM;EACE,UAAA;AA4IR;AFtOI;EEyFE;IAII,UAAA;EA6IR;AACF;AAxIM;EACE,eAAA;AA0IR;AAxIQ;EACE,cAAA;AA0IV;AAvIQ;EACE,aAAA;AAyIV;AFpPI;EE+GM;IACE,aAAA;EAwIV;EArIQ;IACE,cAAA;EAuIV;AACF;;AAhIA;EACE,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;AAmIF;AAjIE;EF3HE,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EE6HA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AAuIJ;AArII;EACE,cAAA;EACA,mBAAA;EACA,aAAA;AAuIN;AApII;EACE,cAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;AAsIN;AAnII;EACE,kBAAA;EACA,mBAAA;AAqIN;AAlII;EACE,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;AAoIN;AAhIE;EACE,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;AAkIJ;;AFtTI;EEyLF;IACE,oBAAA;EAiIF;EA9HA;IACE,mBAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;EAgIF;EA9HE;IACE,aAAA;IACA,gBAAA;IACA,kBAAA;EAgIJ;EA7HE;IACE,SAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,2BAAA;EA+HJ;EA5HE;IFrMA,eAAA;IAAA,eAAA;IAAA,eAAA;IAAA,eAAA;IAAA,eAAA;IEuME,OAAA;IACA,eAAA;IACA,kBAAA;IACA,WAAA;EAkIJ;EAhII;IACE,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,gBAAA;EAkIN;EA/HI;IACE,mBAAA;EAiIN;EA9HI;IACE,kBAAA;IACA,mBAAA;EAgIN;EA7HI;IACE,8BAAA;EA+HN;AACF;AAvHA;EAOE,cAAA;EACA,kBAAA;EACA,gBAAA;AAmHF;AF9WI;EEkPJ;IAEI,uBAAA;IACA,eAAA;IACA,oBAAA;EA8HF;AACF;AAxHE;EACE,YAAA;EACA,eAAA;AA0HJ;AFzXI;EE6PF;IAII,eAAA;EA4HJ;AACF;AAzHE;EACE,6BAAA;EACA,2BAAA;EACA,8BAAA;EACA,qBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;AA2HJ;AAxHE;EACE,iBAAA;AA0HJ;AAvHE;EACE,gEAAA;EACA,qBAAA;EACA,iBAAA;EACA,UAAA;AAyHJ;AAtHE;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;AAwHJ;AArHE;EACE,iBAAA;AAuHJ;AApHE;EACE,mBAAA;EACA,eAAA;EACA,cAAA;AAsHJ;AApHE;EACE,cAAA;EACA,0BAAA;AAsHJ;AAnHE;EACE,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;AAqHJ;AAlHE;EACE,gEAAA;EACA,qBAAA;EACA,iBAAA;EACA,UAAA;AAoHJ;AAjHE;EACE,+CAAA;EACA,yBAAA;EACA,kBAAA;EACA,kDAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;AAmHJ;AAjHE;EACE,qBAAA;EACA,UAAA;AAmHJ;;AA/GA;EACE,mBAAA;AAkHF;AAhHE;EACE,gBAAA;AAkHJ;;AA7GE;EACE,+CAAA;EACA,yBAAA;EACA,kBAAA;EACA,kDAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;AAgHJ;;AA1GA;EACE,eAAA;EACA,qBAAA;AA6GF;AFrdI;EEsWJ;IAKI,eAAA;EA8GF;AACF;;AA3GA;EACE,iCAAA;EACA,iBAAA;AA8GF;AA5GE;EACE,8BAAA;AA8GJ;AA1GE;EACE,mBAAA;AA4GJ;AAzGE;EACE,SAAA;EACA,oBAAA;EACA,kBAAA;AA2GJ;AF1eI;EE4XF;IAQI,eAAA;EA0GJ;AACF;AF/eI;EE+WJ;IA0BI,iBAAA;EA0GF;EAxGE;IACE,8BAAA;EA0GJ;AACF;;AApGA;EACE,aAAA;EACA,eAAA;AAuGF;;AApGA;EACE,gBAAA;AAuGF;;AFhgBI;EE6ZF;IACE,cAAA;IACA,oBAAA;EAuGF;AACF;AApGA;EACE,+BAAA;AAsGF;;AAlGA;EACE,gBAAA;AAqGF;;AAjGE;EACE,eAAA;AAoGJ;AAjGE;EACE,kBAAA;EACA,eAAA;AAmGJ;AAhGE;EACE,iBAAA;AAkGJ;AA/FE;EACE,mBAAA;AAiGJ;AA9FE;EACE,eAAA;EACA,kBAAA;AAgGJ;AFhiBI;EE8bF;IAII,eAAA;EAkGJ;AACF;AA/FE;EACE,mBAAA;AAiGJ;AA9FE;EACE,eAAA;EACA,iCAAA;EACA,kBAAA;AAgGJ;AA3FI;EACE,mBAAA;AA6FN","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.flex-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n}\n\n.flex-item {\n  padding: 5px;\n  width: 600px;\n  min-width: 320px;\n}\n\n@include respond-to (small) {\n  .helper-text {\n    left: 15px !important;\n  }\n}\n\n.success-icon {\n  float: left;\n  padding-top: 5px;\n}\n\n.alert {\n  margin: 20px;\n}\n\n.submitting {\n  height: 50px;\n  margin-left: 45%;\n  width: 50px;\n}\n\n.success-msg {\n  color: #007a3d;\n  margin: 5px;\n  font: 24px/25px 'Omnes-ATT-W02-Light';\n}\n\n.buttons-section {\n  height: 115px;\n  margin-bottom: 100px;\n  max-width: 681px;\n}\n\n// banner section starts here\n.mar-top-20 {\n  margin-top: 20px;\n}\n\n.grid-table {\n  table {\n    margin-bottom: 20px;\n    border-collapse: collapse;\n    border-spacing: 2px;\n\n    tbody {\n      box-sizing: border-box;\n      font-size: 16px;\n\n      td.minPad {\n        padding: 10px 20px;\n\n        @include respond-to (small) {\n          padding: 20px;\n        }\n      }\n\n      td {\n        font-size: 16px;\n        border: 1px solid #d2d2d2;\n        padding: 20px;\n\n        div.extTxt {\n          display: block;\n        }\n\n        div.shortTxt {\n          display: none;\n        }\n\n        @include respond-to (small) {\n          font-size: 14px;\n\n          div.extTxt {\n            display: none;\n          }\n\n          div.shortTxt {\n            display: block;\n          }\n        }\n      }\n\n      td:nth-child(1) {\n        width: 40%;\n\n        @include respond-to (small) {\n          width: 60%;\n        }\n      }\n\n      td:nth-child(2) {\n        width: 30%;\n\n        @include respond-to (small) {\n          width: 20%;\n        }\n      }\n\n      td:nth-child(3) {\n        width: 30%;\n\n        @include respond-to (small) {\n          width: 20%;\n        }\n      }\n    }\n\n    thead {\n      th {\n        font-size: 14px;\n\n        div.cmpTbHdrL {\n          display: block;\n        }\n\n        div.cmpTbHdrS {\n          display: none;\n        }\n\n        @include respond-to (small) {\n          div.cmpTbHdrL {\n            display: none;\n          }\n\n          div.cmpTbHdrS {\n            display: block;\n          }\n        }\n      }\n    }\n  }\n}\n\n.banner-section {\n  align-items: center;\n  height: 500px;\n  overflow: hidden;\n  position: relative;\n  width: calc(100vw - 0.6vw);\n  left: 50%;\n  right: 50%;\n  margin-left: -50vw;\n  margin-right: -50vw;\n\n  .banner-caption {\n    @include vendor-prefix('transform', translateY(-50%));\n    left: 0;\n    padding-left: 10px;\n    position: absolute;\n    top: 50%;\n    width: 100%;\n\n    #bannerNameSection {\n      color: color(inverse, darker);\n      margin-bottom: 10px;\n      margin-top: 0;\n    }\n\n    #efotaBannerNameSection {\n      color: #000000;\n      margin-bottom: 10px;\n      margin-top: 0;\n      width: 67%;\n      line-height: 40px;\n      letter-spacing: 1.33px;\n      opacity: 1;\n      text-align: left;\n    }\n\n    .product-text {\n      margin-left: -15px;\n      margin-right: -15px;\n    }\n\n    .efota-product-text {\n      margin-left: -15px;\n      margin-right: -15px;\n      width: 73%;\n      text-align: left;\n      letter-spacing: 0.48px;\n      color: #000000;\n      opacity: 1;\n    }\n  }\n\n  img {\n    left: 50%;\n    max-width: 1920px;\n    position: absolute;\n    transform: translateX(-50%);\n  }\n}\n\n@include respond-to(small) {\n  .details-page {\n    padding-bottom: 10px;\n  }\n\n  .banner-section {\n    align-items: center;\n    height: auto;\n    overflow: hidden;\n    position: relative;\n\n    figure {\n      height: 266px;\n      overflow: hidden;\n      position: relative;\n    }\n\n    img {\n      left: 50%;\n      width: auto;\n      max-width: 1024px;\n      position: absolute;\n      transform: translateX(-50%);\n    }\n\n    .banner-caption {\n      @include vendor-prefix('transform', none);\n      left: 0;\n      padding-left: 0;\n      position: relative;\n      width: 100%;\n\n      h1 {\n        font-size: 20px;\n        font-weight: bold;\n        margin-bottom: 30px;\n        margin-top: 20px;\n      }\n\n      p {\n        margin-bottom: 30px;\n      }\n\n      .product-text {\n        margin-left: -15px;\n        margin-right: -15px;\n      }\n\n      h2.product-style {\n        margin-bottom: 20px !important;\n      }\n    }\n  }\n}\n\n// banner section end here\n\n// Tab design\n.tab-section {\n  @include respond-to(small) {\n    height: auto !important;\n    margin: 0 -15px;\n    margin-bottom: -10px\n  }\n\n  margin: 30px 0;\n  position: relative;\n  margin-bottom: 0;\n\n  label { \n    color: black;\n    font-size: 16px;\n    @include respond-to(small) {\n      font-size: 14px;\n    }\n  }\n\n  .hidden-accessible {\n    position: absolute !important;\n    clip: rect(1px 1px 1px 1px);\n    clip: rect(1px, 1px, 1px, 1px);\n    padding: 0 !important;\n    border: 0 !important;\n    height: 1px !important;\n    width: 1px !important;\n }\n\n  #productDescription {\n    line-height: 20px;\n  }\n  \n  .tabHeading {\n    font: Medium 15px/26px var(--unnamed-font-family-att-aleck-sans);\n    letter-spacing: 0.4px;\n    font-weight: bold;\n    opacity: 1;\n  }\n\n  img {\n    margin-right: 30px;\n    margin-top: 10px;\n    border: 1px solid #707070;\n  }\n\n  .text-right {\n    text-align: right;\n  }\n\n  .device-link {\n    margin-right: 185px;\n    font-size: 16px;\n    color: #0068ae;\n  }\n  .device-link:hover, .device-link:focus, .underLine:hover, .underLine:focus {\n    color: #23527c;\n    text-decoration: underline;\n  }\n\n  .bold-text {\n    margin-top: 19px;\n    text-align: left;\n    letter-spacing: 0.4px;\n    color: #000000;\n    opacity: 1;\n  }\n\n  #unAuthFormText {\n    font: Medium 15px/26px var(--unnamed-font-family-att-aleck-sans);\n    letter-spacing: 0.4px;\n    font-weight: bold;\n    opacity: 1;\n  }\n\n  #loginBtn1, #loginBtn2, #loginBtn4 {\n    background: #1483D9 0% 0% no-repeat padding-box;\n    border: 1px solid #1A84D8;\n    border-radius: 6px;\n    letter-spacing: var(--unnamed-character-spacing-0);\n    background-color: #1483D9;\n    text-align: center;\n    letter-spacing: 0px;\n    opacity: 1;\n    color: #FFFFFF;\n  }\n  .plainText {\n    letter-spacing: 0.4px;\n    opacity: 1;\n  }\n}\n\n.tab-moreinfo {\n  margin-bottom: 15px;\n\n  p {\n    margin-top: 15px;\n  }\n}\n\n.tab-unauthinfo {\n  .btn {\n    background: #1483D9 0% 0% no-repeat padding-box;\n    border: 1px solid #1A84D8;\n    border-radius: 6px;\n    letter-spacing: var(--unnamed-character-spacing-0);\n    background-color: #1483D9;\n    text-align: center;\n    letter-spacing: 0px;\n    opacity: 1;\n    color: #FFFFFF;\n  }\n}\n\n\n\n.cmptab-header {\n  font-size: 24px;\n  margin: 30px 0 20px 0;\n\n  @include respond-to(small) {\n    font-size: 16px;\n  }\n}\n\n.package-section {\n  background-color: color(default, base);\n  padding-top: 30px;\n\n  .label-style {\n    margin-bottom: 30px !important;\n\n  }\n\n  .msg {\n    margin-bottom: 30px;\n  }\n\n  .tnc {\n    margin: 0;\n    padding-bottom: 10px;\n    padding-left: 15px;\n    // margin: 30px 0;\n\n    @include respond-to(small) {\n      // margin-left: 15px;\n      padding-left: 0;\n    }\n  }\n\n  @include respond-to(small) {\n    padding-top: 20px;\n\n    .label-style {\n      margin-bottom: 20px !important;\n    }\n  }\n}\n\n\n// package tile design start here\n.display-column {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.modal-lg-width {\n  max-width: 720px;\n}\n\n@include respond-to (small) {\n  .display-column {\n    display: block;\n    padding-bottom: 10px;\n  }\n}\n\np.label-style {\n  margin-bottom: 30 px !important;\n\n}\n\nform {\n  margin-top: 10px;\n}\n\napp-form-builder {\n  label {\n    cursor: default;\n  }\n\n  .radio {\n    margin-right: 20px;\n    margin-top: 7px;\n  }\n\n  .checkbox {\n    margin-left: 15px;\n  }\n\n  .link-content {\n    margin-bottom: 15px;\n  }\n\n  .extra-content {\n    font-size: 16px;\n    margin-bottom: 8px;\n    @include respond-to(small) {\n      font-size: 14px;\n    }\n  }\n\n  .text-main {\n    padding-bottom: 0px;\n  }\n\n  .label-content {\n    font-size: 16px;\n    font-family: Omnes-ATT-W02-Medium;\n    margin-bottom: 8px;\n\n  }\n\n  .tooltip-container {\n    i {\n      margin: 4px 0 0 4px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
